import { useEffect, RefObject } from 'react';

const useOutsideClick = (ref: RefObject<HTMLDivElement>, action: () => void): void => {
  useEffect(() => {
    const handleClickOutside = (event: Event): void => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        action();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, action]);
};

export default useOutsideClick;
